









import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import isGranted from '../../auth/isGranted';
import InviteUserModal from './InviteUserModal.vue';

export default Vue.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'fa fa-plus',
    },
    label: {
      type: String,
      default: 'Invite User',
    },
    // A role to automatically assign to the user
    roleType: String,
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        accountId: this.accountId,
        title: this.label,
        roleType: this.roleType,
      };
      openModal(InviteUserModal, config).onOk((user) => {
        this.$emit('invited', user);
      });
    },
    isGranted,
  },
});
